import { withTranslation as originalWithTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import React from 'react';

import { TranslationProps } from 'etc/types';

// We roll our own fallback of not using Suspenses (similar to older version of i18n with wait:true config)
const tWithEmptyFallback = (t: TFunction, ready: boolean) => (str: string, conf: object) => ready ? t(str, conf) : '';

// translateRaw - allow html in the translation string.
// Needed since we have lots of <strong>, <a>, in the existing translate files.
// In the future, we should try to not put html in the translate strings.
const traw = (t: TFunction, ready: boolean) => (str: string, conf: object) =>
  (
    // eslint-disable-next-line react/no-danger
    <span
      dangerouslySetInnerHTML={{
        __html: tWithEmptyFallback(t, ready)(str, conf),
      }}
    />
  );

const withTranslation =
  (ns?: string, opt?: object) =>
  <P extends TranslationProps>(Comp: React.ComponentType<P>) => {
    return originalWithTranslation(
      ns,
      opt,
    )<Omit<P, 'traw'>>(props => (
      <Comp {...(props as P)} t={tWithEmptyFallback(props.t, props.tReady)} traw={traw(props.t, props.tReady)} />
    ));
  };

export default withTranslation;
